import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import Breweries from "../../component/solutionscomponent/Breweries";

const BreweriesPage = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <Breweries />
        <Footer />
      </section>
    </>
  );
};

export default BreweriesPage;
